
import { Card } from "@/components/ui/card";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";

interface JourneyTheme {
  id: string;
  title: string;
  description: string;
  color: string;
  hoverColor: string;
  textColor: string;
}

const journeyThemes: JourneyTheme[] = [
  {
    id: "peace",
    title: "Journey to Peace",
    description: "Find calm and relief from anxiety",
    color: "bg-[#D3E4FD]",
    hoverColor: "hover:bg-[#BED6F9]",
    textColor: "text-black",
  },
  {
    id: "hope",
    title: "Journey to Hope",
    description: "Discover God's promises and faithfulness",
    color: "bg-[#FEF7CD]",
    hoverColor: "hover:bg-[#FDF0B0]",
    textColor: "text-black",
  },
  {
    id: "strength",
    title: "Journey to Strength",
    description: "Find power in times of weakness",
    color: "bg-[#FEC6A1]",
    hoverColor: "hover:bg-[#FDB88A]",
    textColor: "text-black",
  },
  {
    id: "joy",
    title: "Journey to Joy",
    description: "Embrace God's goodness and light",
    color: "bg-[#FFDEE2]",
    hoverColor: "hover:bg-[#FFD0D6]",
    textColor: "text-black",
  },
  {
    id: "courage",
    title: "Journey to Courage",
    description: "Face uncertainty with faith",
    color: "bg-[#D6BCFA]",
    hoverColor: "hover:bg-[#C4A3F7]",
    textColor: "text-black",
  },
  {
    id: "gratitude",
    title: "Journey to Gratitude",
    description: "Cultivate thankfulness in all seasons",
    color: "bg-[#F2FCE2]",
    hoverColor: "hover:bg-[#E5F9CB]",
    textColor: "text-black",
  },
];

export function ScriptureJourneys() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold mb-2">Scripture Journeys</h2>
        <p className="text-muted-foreground">
          Explore guided paths through scripture based on your spiritual needs
        </p>
      </div>
      
      <AnimatePresence>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {journeyThemes.map((theme) => (
            <motion.div
              key={theme.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
              layout
            >
              <Card
                className={`p-6 cursor-pointer transition-colors ${theme.color} ${theme.hoverColor}`}
                onClick={() => navigate(`/journey/${theme.id}`)}
              >
                <h3 className={`text-lg font-semibold mb-2 ${theme.textColor}`}>
                  {theme.title}
                </h3>
                <p className={`text-sm ${theme.textColor}`}>
                  {theme.description}
                </p>
              </Card>
            </motion.div>
          ))}
        </div>
      </AnimatePresence>
    </div>
  );
}
